// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_32UTB","visuallyhidden":"_2pDKq","hide-text":"_2SBBB","center":"_3k--R","noprint":"_3OeRt","divider":"_2LB98","listGroup":"_1-Ozm","title":"_1Z4x2","title-Open":"_11F2O","sitemapList":"_1iSvI","sitemapLink":"H4-qI","sitemapLink-Open":"_2YvPI","sublist":"_3Pu9-","sublistItem":"_1w7ZZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/SiteMap.scss
 ** module id = 970
 ** module chunks = 1
 **/